import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { runtimeConfig } from "@src/runtime-config";
import { Link } from "@flat-ui";
import { isLocalhost } from "@faro-lotv/foundation";
const shouldShowCommitHash = runtimeConfig.commitId && runtimeConfig.commitId !== "0";
const shouldShowPRLink = runtimeConfig.pullRequestId && runtimeConfig.pullRequestId !== "0" && runtimeConfig.pullRequestUrl && runtimeConfig.pullRequestUrl !== "0";
const shouldShowJiraLink = runtimeConfig.jiraTicketUrl && runtimeConfig.jiraTicketUrl !== "0" && runtimeConfig.jiraTicketId && runtimeConfig.jiraTicketId !== "0";
const maxCommitHashLength = 8;
export const commitSimplifiedHash = runtimeConfig.commitId.slice(0, maxCommitHashLength);

/**
 * Shows additional information in the about dialog for local development, like the commit SHA and the pull request ID.
 */
export function AboutLocalInfo() {
  const $ = _c(2);
  const appVersion = isLocalhost() ? `Localhost ${runtimeConfig.appEnv}` : runtimeConfig.appVersion;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fontSize: "14px",
      color: "text.primary"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box component="div"><Box component="div" sx={t0}>Version: <var>{appVersion}</var><br />{shouldShowCommitHash && <>Commit SHA{" "}<Link href={runtimeConfig.commitUrl} target="_blank"><var>{commitSimplifiedHash}</var></Link><br /></>}{shouldShowJiraLink && <>Jira Ticket{" "}<Link href={runtimeConfig.jiraTicketUrl} target="_blank"><var>{runtimeConfig.jiraTicketId}</var></Link><br /></>}{shouldShowPRLink && <>Pull Request Id{" "}<Link href={runtimeConfig.pullRequestUrl} target="_blank"><var>{runtimeConfig.pullRequestId}</var></Link></>}</Box></Box>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}